module.exports = __webpack_public_path__ + "static/media/BCT.2e6e8f0f.png";